export default "__VITE_ASSET__BkDfE5Qv__"